import apiClient from './client';
import type { ShopifyAnalytics } from '../types/commerceAnalytics';

/**
 * Client for the Shopify commerce analytics endpoint.
 *
 * One round trip returns the daily revenue + order-count series and a
 * summary block for a single window. The backend clamps `days` to [1, 730]
 * and caches each window for ~30 minutes, so any UI selection is safe and
 * repeated opens are cheap. Pass `refresh` to bypass the server cache.
 */
export async function getShopifyAnalytics(
  days: number = 90,
  refresh: boolean = false
): Promise<ShopifyAnalytics> {
  const { data } = await apiClient.get<ShopifyAnalytics>(
    '/admin/shopify/analytics/',
    { params: { days, ...(refresh ? { refresh: 1 } : {}) } }
  );
  return data;
}
